import { useQueryClient, QueryKey, UseQueryOptions } from "@tanstack/react-query";

type QueryFn<TData, TParams extends any> = (args: TParams) => Promise<TData>;

function useCustomLazyQuery<TData, TParams extends any>(
  queryKey: QueryKey,
  queryFn: QueryFn<TData, TParams>,
  options?: Omit<UseQueryOptions<TData, Error, TData, QueryKey>, "queryKey" | "queryFn">
) {
  const queryClient = useQueryClient();

  const lazyQuery = async (args: TParams): Promise<TData> => {
    return queryClient.ensureQueryData({
      queryKey,
      queryFn: () => queryFn(args),
      ...options,
    });
  };

  return { lazyQuery };
}

export default useCustomLazyQuery;
